/* ConvertBoost© */
cmmSetupConvertBoost({
    cta_options: [{
        mode: 'modal',
        icon: 'phone',
        icon_size: 'medium',
        color: '#2b388f',
        border: '4px solid #ffd400',
        text: 'Contact Us',
        text_shadow: '2px 2px 2px rgba(0,0,0,.2)',
        devices: ['desktop', 'laptop'],
        font: {
          family: "AUTO"
        },
      },  {
        mode: 'modal',
        icon: 'phone',
        color: '#2b388f',
        text_shadow: '2px 2px 2px rgba(0,0,0,.2)',
        devices: ['tablet', 'mobile'],
    }],
   modal_options: {
    header_text: '<img style="max-width:300px;" src="https://i4searchgroup.com/wp-content/uploads/2021/04/cropped-i4-Search-Group-2-231x67-1-1.png-1.png">',
    header_color: '#ffffff',
    description_text : 'We specialize in recruiting for Nursing, Allied Health, Advanced Practice, Physician, as well as Leadership and Administration positions.',
        font: {
          family: "AUTO"
        },
    buttons: [{
      title: 'EMAIL US',
      link: 'mailto:info@i4searchgroup.com',
      txt_color_hover: '#01167F',
      bg_color: '#01167F',
      class_list: [
        'email-us'
      ],
      icon: 'email'
    },{
      title: 'TEXT US',
      link: 'sms:+13136313414',
      txt_color_hover: '#01167F',
      bg_color: '#01167F',
      class_list: [
        "text-us"
      ],
      icon: 'sms-solid'
    }, {
      title: 'SEARCH JOBS',
      link: '/search-jobs/',
      txt_color_hover: '#01167F',
      bg_color: '#01167F',
      class_list: [
        'search-jobs'
      ],
      icon: 'search'
    }, {
      title: 'FIND TALENT',
      link: '/find-talent/',
      txt_color_hover: '#01167F',
      bg_color: '#01167F',
      class_list: [
        'find-talent'
      ],
      icon: 'search'
    }],
    footer_text: 'i4 Search Group Healthcare Recruiting is dedicated to matching Healthcare Heroes with the careers they deserve at world class facilities<br/>across North America.',
    footer_color: '#90939c'
  }
}).then( _ => {
  /* ConvertBoost©  Event Tracking */
  cmmSetupEventTracking([{
    selector:'#cmm-call-to-action-modal .email-us',
    action: 'Email info@i4searchgroup.com - ConvertBoost©',
    event: 'click'
  },{
    selector:'#cmm-call-to-action-modal .text-us',
    action: 'Text (313) 631-3414 - ConvertBoost©',
    event: 'click'
  }, {
    selector:'#cmm-call-to-action-modal .search-jobs',
    action: 'Search Jobs - ConvertBoost©',
    event: 'click'
  }, {
    selector:'#cmm-call-to-action-modal .find-talent',
    action: 'Find Talent - ConvertBoost©',
    event: 'click'
  }]);
});